import React, { forwardRef } from 'react';
import ReactMarkdown from 'react-markdown';

import { FileUploader } from '../../../../FileUploader';
import { cn } from '../../../../../utils';

export const ChatMessage = forwardRef(
  (
    {
      speaker,
      text,
      input,
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={cn(
        'py-3 px-3 md:px-6 w-full dark:border-white/25 flex flex-col max-w-4xl overflow-hidden scroll-pb-32',
        speaker === 'user'
          ? ''
          : 'bg-gray-200 dark:bg-gray-800 bg-opacity-60 py-8',
      )}
      style={speaker === 'user' ? { whiteSpace: 'pre-line' } : {}}
    >
      <span
        className={cn(
          'capitalize  text-xs bg-sky-200 rounded-xl p-1 px-2 mb-2 w-fit  dark:bg-sky-700',
        )}
        data-testid="chat-message-speaker"
      >
        {speaker}
      </span>
      <div data-testid="chat-message-text">
        <ReactMarkdown className="prose dark:prose-invert ml-[6px]  mt-1">
          {text}
        </ReactMarkdown>
        {input === 'upload' ? <FileUploader /> : ''}
      </div>
    </div>
  ),
);

ChatMessage.displayName = 'ChatMessage';

export default ChatMessage;
